import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import FeedTable from '@app/components/apps/FeedProduction/FeedComponent';
import FeedForecastComponent from '@app/components/apps/FeedForecast/FeedForecastComponent';

export const ViewFeedForecast: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Product Forecast');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    { path: '/feed-forecasts', breadcrumbName: 'Feed Forecast' },
    { path: `/view-feed-forecast/${id}`, breadcrumbName: 'View Feed Forecast' },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <FeedForecastComponent
          type={'view'}
          editable={false}
          id={id}
          pageTitle={`View Feed Forecast`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default ViewFeedForecast;
